import React from 'react'
import App from './App'

export default function DirectorsAuditTrails({ appProps, screenClass, auditTrails, pagination, title, description, labels }) {
  function formatDate(value) {
    if (!value) return '-'

    return new Date(value).toLocaleString()
  }

  function digestLabel(value) {
    if (!value) return '-'

    return value.length > 18 ? `${value.slice(0, 18)}...` : value
  }

  function renderAccount(account, withLink = false) {
    if (!account || !account.id) return <span className='director-empty'>-</span>

    return (
      <div className='director-account-main'>
        <div className='director-inline-link'>
          <strong>{ labels.uid } { account.uid }</strong>
          { withLink && account.showPath && (
            <a href={ account.showPath } className='director-icon-link' title={ labels.viewAccount }>
              <i className='fa-light fa-eye'></i>
            </a>
          ) }
        </div>
        <span>{ account.email || '-' }</span>
      </div>
    )
  }

  function renderPaginationItems() {
    let lastNumber = null

    return pagination.pages.map(page => {
      const showGap = lastNumber && page.number > lastNumber + 1
      lastNumber = page.number

      return (
        <React.Fragment key={ page.number }>
          { showGap && <span className='director-pagination-gap'>...</span> }
          <a
            href={ page.path }
            className={ `director-page-link ${page.current ? 'active' : ''}` }>
            { page.number }
          </a>
        </React.Fragment>
      )
    })
  }

  return (
    <App appProps={ appProps }>
      <div className={ screenClass }>
        <div className='director-shell'>
          <section className='director-header'>
            <div>
              <span>{ labels.eyebrow }</span>
              <h1>{ title }</h1>
              <p>{ description }</p>
            </div>
          </section>

          <section className='director-table director-audit-table'>
            <div className='director-table-head'>
              <div>{ labels.changedAt }</div>
              <div>{ labels.director }</div>
              <div>{ labels.targetAccount }</div>
              <div>{ labels.accountEmail }</div>
              <div>{ labels.change }</div>
            </div>

            { auditTrails.map(auditTrail => (
              <article key={ auditTrail.id } className='director-audit-row'>
                <div className='director-activity'>
                  <span>{ formatDate(auditTrail.createdAt) }</span>
                </div>

                { renderAccount(auditTrail.director) }

                { renderAccount(auditTrail.targetAccount, true) }

                <div className='director-email-list'>
                  <div className='director-pill'>
                    <div className='director-pill-line'>
                      <span>{ auditTrail.accountEmail?.email || '-' }</span>
                    </div>
                    { auditTrail.accountEmail?.primary && <strong>{ labels.primary }</strong> }
                    { auditTrail.accountEmail?.unconfirmed && <strong>{ labels.unconfirmed }</strong> }
                  </div>
                </div>

                <div className='director-audit-change'>
                  <div>
                    <span>{ labels.previousDigest }</span>
                    <code title={ auditTrail.previousEmailDigest }>{ digestLabel(auditTrail.previousEmailDigest) }</code>
                  </div>
                  <div>
                    <span>{ labels.newDigest }</span>
                    <code title={ auditTrail.newEmailDigest }>{ digestLabel(auditTrail.newEmailDigest) }</code>
                  </div>
                  <em>{ labels.primaryChanged }: { auditTrail.primaryChanged ? labels.yes : labels.no }</em>
                </div>
              </article>
            )) }

            { !auditTrails.length && (
              <div className='director-empty-state'>
                { labels.noAuditTrails }
              </div>
            ) }
          </section>

          { pagination.totalPages > 1 && (
            <div className='director-pagination'>
              <a className='director-page-jump' href={ pagination.firstPath }>
                { labels.firstPage }
              </a>
              <div className='director-page-list'>
                { renderPaginationItems() }
              </div>
              <a className='director-page-jump' href={ pagination.lastPath }>
                { labels.lastPage }
              </a>
            </div>
          ) }
        </div>
      </div>
    </App>
  )
}
